import { render, staticRenderFns } from "./notification-bar.vue?vue&type=template&id=7346320c&scoped=true&"
import script from "./notification-bar.vue?vue&type=script&lang=js&"
export * from "./notification-bar.vue?vue&type=script&lang=js&"
import style0 from "./notification-bar.vue?vue&type=style&index=0&id=7346320c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7346320c",
  null
  
)

export default component.exports